<i18n>
{
    "ar": {
        
    },
    "en": {
        
    }
}
</i18n>
<template>
    <div class="page page-sections">
        <v-container style="min-height: 75vh" class="py-lg-12 d-flex align-center justify-center flex-column" :class="{'px-0 py-2': phoneOnly}">
            <v-card v-if="invoice" :min-width="pcOnly ? 500 : null" class="search-card px-2 py-1">
                <v-progress-linear v-if="paying" absolute top indeterminate color="secondary" height="3"></v-progress-linear>
                <v-card-title class="d-flex justify-space-between">
                    <div>فاتورة رقم #{{id}}</div>
                    <div>
                        <v-btn icon class="grey lighten-4" :to="{name: 'invoices'}" exact>
                            <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text class="px-lg-4 pb-0">
                    <v-alert v-if="paymentSuccess || invoice.paid" dense type="success" text>
                        <div v-if="paymentSuccess" class="black--text">شكراً لك! لقد تمت عملية الدفع بنجاح.</div>
                        <div v-else class="black--text">لقد تم دفع هذه الفاتورة سابقاً</div>
                    </v-alert>
                    <v-row>
                        <v-col cols="12" class="px-0 py-1" lg="6">
                            <v-list>
                                <v-list-item>
                                    <v-list-item-icon class="me-4">
                                        <v-icon color="primary">mdi-account-tie</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle class="mb-1">اسم العميل</v-list-item-subtitle>
                                        <v-list-item-title>{{invoice.client_name}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon class="me-4">
                                        <v-icon color="primary">mdi-cash</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle class="mb-1">المبلغ المستحق</v-list-item-subtitle>
                                        <v-list-item-title>
                                            <div style="direction: ltr;" class="text-right">
                                                <span class="font-weight-bold ms-1 indigo--text text--darken-1">{{moneyFormat(invoice.amount_with_fees)}}</span>
                                                <sup>{{invoice.currency}}</sup>
                                            </div>
                                        </v-list-item-title>
                                        <v-list-item-subtitle v-if="invoice.fees" class="mt-1">
                                            <span style="font-size: 12px">مضاف إلى المبلغ <b class="error--text">{{moneyFormat(invoice.fees)}}$</b> رسوم العملية.</span>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col cols="12" class="px-0 py-1" lg="6">
                            <v-list>
                                <v-list-item>
                                    <v-list-item-icon class="me-4">
                                        <v-icon color="primary">mdi-email</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle class="mb-1">البريد اﻹلكتروني</v-list-item-subtitle>
                                        <v-list-item-title>{{invoice.client_email}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon class="me-4">
                                        <v-icon :color="invoice.status === 'paid' ? 'success' : 'error'">
                                            {{invoice.status === 'paid' ? 'mdi-cash-check' : 'mdi-alert-decagram-outline'}}
                                        </v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle class="mb-1">الحالة</v-list-item-subtitle>
                                        <v-list-item-title>
                                            <span v-if="invoice.status === 'paid'">مدفوع</span>
                                            <span v-else-if="invoice.status === 'due'">في انتظار الدفع</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                    <div>
                        <!-- <v-btn block color="primary" @click="showPayInputs = true">
                            <v-icon left>mdi-credit-card-outline</v-icon>
                            ادفع بالبطاقة الإئتمانية أو بايبال
                        </v-btn> -->
                        <div v-if="invoice" class="mt-6">
                            <paypal-buttons :disabled="paying || invoice.paid" :amount="invoice.amount_with_fees" @captured="completePayment" @error="paymentFailed" />
                        </div>    
                    </div>
                </v-card-text>
            </v-card>
            <div v-else>
                <v-progress-circular transition="fade-transition" indeterminate width="3" size="35" color="secondary"></v-progress-circular>
            </div>
        </v-container>
        <e-footer />
        <scroll-to-top />
    </div>
</template>

<script>
// @ is an alias to /src
import 'particles.js';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles


import ScrollToTop from '@/components/custom/scroll-to-top'
import EFooter from '@/components/main/e-footer'


import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import PaypalButtons from '@/components/custom/paypal-buttons'

export default {
    name: "Invoices",
    components: {
        ScrollToTop,
        EFooter,
        PaypalButtons
    },
    data(){
        return {
            serialNumber: '',
            loading: false,
            
            showPayInputs: false,
            paying: false,
            
            invoice: null,
            
            paymentSuccess: false,
        }
    },
    computed: {
        id(){
            return this.$route.params.id;
        },
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods,
        getInvoice(){
            if (!this.loading){
                this.loading = true;
                window.axios.get('/invoices/' + this.id).then(response=>{
                    this.invoice = response.data.data;
                }).catch(e=>{
                    if (e && e.response && e.response.status === 404){
                        this.$router.push({name: 'invoices', query: {error: '404'}});
                    }
                })
            }
        },
        paymentFailed(){

        },
        completePayment(captureResponse){
            const data = {
                transaction_id: captureResponse.id
            };
            this.paying = true;
            window.axios.post('/invoices/' + this.id, data).then((response)=>{
                this.paying = false;
                this.paymentSuccess = true;
                const invoice = response.data.data;
                this.invoice = invoice;
            }).catch(e=>{
                // this.showMsg('Error occurred during completing your payment, please contact support');
                this.paying = false;
            });
        }
    },
    watch: {
        id(){
            this.getInvoice();
        }
    },

    mounted(){
        this.getInvoice();
        AOS.init({container: document.documentElement, once: true, easing: 'ease'});
    }
};
</script>
<style lang="scss" scoped>
.search-card{
    box-shadow: none!important;
    @media(min-width: 960px){
        box-shadow: 0 4px 8px 2px rgba(0,0,0, .1)!important;
    }
}
</style>

<style lang="scss">
.v-list-item__content > *{
    line-height: 1.4!important;
}
</style>